import React from "react";

import { FontAwesomeIcon }
from "@fortawesome/react-fontawesome";

import
{
    faCrosshairs,
    faChevronDown,
    faClipboard
}
from "@fortawesome/free-solid-svg-icons";


export default function AiAssetCard(
{
    asset,
    expanded,
    onToggle,
    onLocate,
    onDetail
})
{

    //--------------------------------------------------------
    // Condition style
    //--------------------------------------------------------

    const conditionStyle =

        asset.condition === "GOOD"

            ?

            {
                background:
                    "rgba(46,204,113,.18)",

                border:
                    "1px solid rgba(46,204,113,.45)",

                color:
                    "#7dffb1"
            }

        :

        asset.condition === "FAIR"

            ?

            {
                background:
                    "rgba(243,156,18,.18)",

                border:
                    "1px solid rgba(243,156,18,.45)",

                color:
                    "#ffd27a"
            }

        :

        asset.condition === "POOR"

            ?

            {
                background:
                    "rgba(214,40,40,.18)",

                border:
                    "1px solid rgba(214,40,40,.45)",

                color:
                    "#ff9b9b"
            }

        :

            {
                background:
                    "rgba(120,120,120,.18)",

                border:
                    "1px solid rgba(180,180,180,.30)",

                color:
                    "#dddddd"
            };


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div

            onClick={onToggle}

            style={{

                marginBottom:
                    "8px",

                padding:
                    "10px 16px",

                borderRadius:
                    "0px",

                background:
                    "linear-gradient(" +
                    "180deg, " +
                    "rgba(255,255,255,.055) 0%, " +
                    "rgba(255,255,255,.025) 100%" +
                    ")",

                border:
                    "1px solid rgba(255,255,255,.08)",

                overflow:
                    "hidden",

                cursor:
                    "pointer",

                transition:
                    "all .25s ease"
            }}

        >

            {/* ------------------------------------------------
                Main row
                ------------------------------------------------ */}

            <div

                style={{

                    display:
                        "flex",

                    alignItems:
                        "center"
                }}

            >

                {/* --------------------------------------------
                    Asset image
                    -------------------------------------------- */}

                <img

                    src={
                        `https://picsum.photos/seed/${asset.id}/64`
                    }

                    alt=""

                    style={{

                        width:
                            "44px",

                        height:
                            "44px",

                        borderRadius:
                            "50%",

                        objectFit:
                            "cover",

                        flexShrink:
                            0,

                        border:
                            "2px solid rgba(255,255,255,.15)"
                    }}

                />


                {/* --------------------------------------------
                    Asset information
                    -------------------------------------------- */}

                <div

                    style={{

                        flex:
                            1,

                        marginLeft:
                            "14px"
                    }}

                >

                    <div

                        style={{

                            color:
                                "white",

                            fontWeight:
                                600,

                            fontSize:
                                "14px"
                        }}

                    >

                        {asset.name}

                    </div>


                    <div

                        style={{

                            marginTop:
                                "3px",

                            color:
                                "rgba(255,255,255,.65)",

                            fontSize:
                                "12px"
                        }}

                    >

                        {asset.assetType}

                    </div>


                    <div

                        style={{

                            marginTop:
                                "2px",

                            color:
                                "#42bff5",

                            fontSize:
                                "11px"
                        }}

                    >

                        {asset.location}

                    </div>

                </div>


                {/* --------------------------------------------
                    Actions
                    -------------------------------------------- */}

                <div

                    style={{

                        display:
                            "flex",

                        alignItems:
                            "center",

                        gap:
                            "10px"
                    }}

                >

                    {/* ----------------------------------------
                        Details
                        ---------------------------------------- */}

                    <div

                        onClick={(e) =>
                        {

                            e.stopPropagation();

                            onDetail();

                        }}

                        style={{

                            width:
                                "28px",

                            height:
                                "28px",

                            borderRadius:
                                "50%",

                            display:
                                "flex",

                            alignItems:
                                "center",

                            justifyContent:
                                "center",

                            background:
                                "linear-gradient(" +
                                "180deg, " +
                                "#42bff5 0%, " +
                                "#159bd7 100%" +
                                ")",

                            color:
                                "white",

                            cursor:
                                "pointer",

                            boxShadow:
                                "0 4px 10px rgba(21,155,215,.30)",

                            transition:
                                ".2s"
                        }}

                    >

                        <FontAwesomeIcon
                            icon={faClipboard}
                        />

                    </div>


                    {/* ----------------------------------------
                        Locate
                        ---------------------------------------- */}

                    <div

                        onClick={(e) =>
                        {

                            e.stopPropagation();

                            onLocate();

                        }}

                        style={{

                            width:
                                "28px",

                            height:
                                "28px",

                            borderRadius:
                                "50%",

                            display:
                                "flex",

                            alignItems:
                                "center",

                            justifyContent:
                                "center",

                            background:
                                "linear-gradient(" +
                                "180deg, " +
                                "#42bff5 0%, " +
                                "#159bd7 100%" +
                                ")",

                            color:
                                "white",

                            cursor:
                                "pointer",

                            boxShadow:
                                "0 4px 10px rgba(21,155,215,.30)",

                            transition:
                                ".2s"
                        }}

                    >

                        <FontAwesomeIcon
                            icon={faCrosshairs}
                        />

                    </div>


                    {/* ----------------------------------------
                        Expand / collapse
                        ---------------------------------------- */}

                    <FontAwesomeIcon

                        icon={faChevronDown}

                        style={{

                            color:

                                expanded

                                    ?

                                    "#42bff5"

                                    :

                                    "rgba(255,255,255,.65)",

                            fontSize:
                                "13px",

                            transform:

                                expanded

                                    ?

                                    "rotate(180deg)"

                                    :

                                    "rotate(0deg)",

                            transition:
                                "transform .35s ease"
                        }}

                    />

                </div>

            </div>


            {/* ------------------------------------------------
                Expanded information
                ------------------------------------------------ */}

            <div

                style={{

                    maxHeight:

                        expanded

                            ?

                            "220px"

                            :

                            "0px",

                    opacity:

                        expanded

                            ?

                            1

                            :

                            0,

                    overflow:
                        "hidden",

                    transition:
                        "max-height .35s ease, " +
                        "opacity .25s ease, " +
                        "margin-top .35s ease",

                    marginTop:

                        expanded

                            ?

                            "14px"

                            :

                            "0px"
                }}

            >

                {/* --------------------------------------------
                    Description
                    -------------------------------------------- */}

                <div

                    style={{

                        color:
                            "rgba(255,255,255,.78)",

                        fontSize:
                            "13px",

                        lineHeight:
                            "19px"
                    }}

                >

                    {asset.description}

                </div>


                {/* --------------------------------------------
                    Asset tags
                    -------------------------------------------- */}

                <div

                    style={{

                        display:
                            "flex",

                        flexWrap:
                            "wrap",

                        gap:
                            "8px",

                        marginTop:
                            "14px"
                    }}

                >

                    <div style={tagStyle}>

                        {asset.manufacturer}

                    </div>


                    <div style={tagStyle}>

                        {asset.model}

                    </div>


                    <div

                        style={{

                            ...tagStyle,

                            ...conditionStyle,

                            fontWeight:
                                700
                        }}

                    >

                        {asset.condition}

                    </div>


                    <div style={tagStyle}>

                        {asset.assetCode}

                    </div>

                </div>

            </div>

        </div>

    );

}


//--------------------------------------------------------
// Tag style
//--------------------------------------------------------

const tagStyle =
{
    padding:
        "5px 10px",

    borderRadius:
        "0px",

    background:
        "rgba(66,191,245,.12)",

    border:
        "1px solid rgba(66,191,245,.30)",

    color:
        "#8edcff",

    fontSize:
        "11px",

    fontWeight:
        500
};